<div class="splash">

</div>
<div class="splash_logo">
    <img src="assets/logo_splash.png" width="40%" />
</div>